var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpensquareLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0867 16L28.1579 12L36.4724 7.2L47.905 13.8V18.2L36.4724 24.8L28.1579 20L35.0867 16Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8433 20L12.9145 16L19.8433 12L11.5287 7.2L0.0961914 13.8V18.2L11.5287 24.8L19.8433 20Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 24L30.9294 28L24.0006 32L17.0718 28L24.0006 24Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9294 4L24.0006 0L17.0718 4L24.0006 8L30.9294 4Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.9184,
    y1: 16,
    x2: 0.0961908,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6848FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 46.9184,
    y1: 16,
    x2: 0.0961908,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6848FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 46.9184,
    y1: 16,
    x2: 0.0961908,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6848FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 46.9184,
    y1: 16,
    x2: 0.0961908,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6848FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensquareLogoIcon);
export default __webpack_public_path__ + "static/media/opensquare-logo-icon.24650bc705bd7bf2c65d2a594834a35d.svg";
export { ForwardRef as ReactComponent };